import {FileText,X} from 'lucide-react';
import type {PdfConfigurationSource} from '../pdf-configuration';
import ipadOutlineWand from '../assets/ipad-symbols/wand.and.stars.png';
import '../pdf-configuration.css';

export function PdfConfigurationButton({onConfigure,menu=false}:{onConfigure?:()=>void;menu?:boolean}){
  if(!onConfigure)return null;
  return <button type="button" className={menu?undefined:'icon-button'} data-menu-action={menu?true:undefined}
    aria-label="一键配置" title="一键配置" onClick={onConfigure}>
    <span aria-hidden="true" className="pdf-configuration-symbol" style={{maskImage:`url("${ipadOutlineWand}")`,WebkitMaskImage:`url("${ipadOutlineWand}")`}}/>{menu&&'一键配置'}
  </button>;
}

export function PdfConfigurationAttachment({source,onRemove,disabled=false}:{source:PdfConfigurationSource;onRemove:()=>void;disabled?:boolean}){
  return <div className="chat-ipad-import-strip pdf-configuration-attachment" aria-label="待配置 PDF">
    <span><FileText size={15}/><span title={source.name}>{source.name}</span>
      <button type="button" aria-label={`移除配置资料 ${source.name}`} disabled={disabled} onClick={onRemove}><X size={12}/></button>
    </span>
  </div>;
}
